import { Checkbox, Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import {
  CommissionByMovementCalculationType,
  CommissionByMovementReportType,
} from '@/core/domain/questReport/Reports/CommssionByMovement/CommissionByMovement.types';

const ByMovimentsSelectReportType = () => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Row>
      <Col xs={15}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'byMovimentsForm.form.reportYype',
          })}
        </Title>
        <Form.Item
          name="reportType"
          initialValue={CommissionByMovementReportType.estimatorSeller}
        >
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={CommissionByMovementReportType.estimatorSeller}>
              {intl.formatMessage({
                id: 'byMovimentsForm.form.reportYype.salesmanEstimator',
              })}
            </Radio>
            <Radio value={CommissionByMovementReportType.employeePerOsItem}>
              {intl.formatMessage({
                id: 'byMovimentsForm.form.reportYype.employeePerItem',
              })}
            </Radio>
            <Radio value={CommissionByMovementReportType.paintedPart}>
              {intl.formatMessage({
                id: 'byMovimentsForm.form.reportYype.paintedPiece',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col xs={6}>
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            const reportType = getFieldValue('reportType');

            if (reportType === CommissionByMovementReportType.employeePerOsItem)
              return (
                <Col>
                  <Title level={5}>
                    {intl.formatMessage({
                      id: 'byMovimentsForm.form.selectCalculationType.title',
                    })}
                  </Title>
                  <Form.Item
                    name="calculationType"
                    initialValue={CommissionByMovementCalculationType.baseValue}
                  >
                    <Radio.Group
                      buttonStyle="solid"
                      optionType="button"
                      size="large"
                    >
                      <Radio
                        value={CommissionByMovementCalculationType.baseValue}
                      >
                        {intl.formatMessage({
                          id: 'byMovimentsForm.form.selectCalculationType.baseValue',
                        })}
                      </Radio>
                      <Radio
                        value={CommissionByMovementCalculationType.liquidValue}
                      >
                        {intl.formatMessage({
                          id: 'byMovimentsForm.form.selectCalculationType.netValue',
                        })}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              );
            return null;
          }}
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            const reportType = getFieldValue('reportType');

            if (reportType === CommissionByMovementReportType.paintedPart)
              return (
                <Form.Item name="onlyPrivate" noStyle valuePropName="checked">
                  <Checkbox>Particular</Checkbox>
                </Form.Item>
              );

            return (
              <Row>
                <Col>
                  <Form.Item
                    name="detailSoldItems"
                    noStyle
                    valuePropName="checked"
                  >
                    <Checkbox>
                      {intl.formatMessage({
                        id: 'byMovimentsForm.form.selectCalculationType.checkbox.detailItemsSold',
                      })}
                    </Checkbox>
                  </Form.Item>
                  <Form.Item name="onlyPrivate" noStyle valuePropName="checked">
                    <Checkbox>Particular</Checkbox>
                  </Form.Item>
                </Col>

                <Col>
                  {reportType !==
                  CommissionByMovementReportType.employeePerOsItem ? null : (
                    <Form.Item
                      name="inhibitLiquidValue"
                      noStyle
                      valuePropName="checked"
                    >
                      <Checkbox>
                        {intl.formatMessage({
                          id: 'byMovimentsForm.form.selectCalculationType.checkbox.inhibitNetValue',
                        })}
                      </Checkbox>
                    </Form.Item>
                  )}
                </Col>
              </Row>
            );
          }}
        </Form.Item>
      </Col>
    </Row>
  );
};

export default ByMovimentsSelectReportType;
